import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getCurrentNode, getNodesEnriched } from '../../reducers/nav/selectors';
import LoadingSpinner from '../forms/LoadingSpinner';
import { GetRegion, CAROUSEL } from '../../constants';
import { nodeSelected } from '../../reducers/nav/actions';
import FiltersContainer from '../navigation-filters/filters-container';
import { getAssets } from '../../reducers/responseAsset';
import CarouselsDisplay from '../../containers/CarouselsDisplay';
import{fetchEpgLineaUp} from 'action-creators/lineaUp'
import CarouselMatch from './CarouselMatch';
import CarouselSeleccion from './componets/carouselSeleccion/CarouselSeleccion';
import InfiniteList from 'components/carousel/InfiniteList';
import NavigationWrapper from '../NavigationWrapper';
import ContentList from './ContentList';

const TYPE_HIGHLIGHT = 'Highlight';
const TYPE_HORIZONTAL = 'Carrouselhorizontal';
const TYPE_VERTICAL = 'Carrouselvertical';
const MY_CONTENT_LOCATION = 'micontenido';
const CAROUSEL_MUSIC = 'GENERICCLAROMUSICARIBBON';
const ANONYMOUS = 'ANONYMOUS';

export class HomeCarousels extends React.Component {
  constructor(props) {
    super(props);
    this.carrousels = [];
    this.state = {
      displayed: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.fetchLineaUp();
    if (window.location.href.indexOf(MY_CONTENT_LOCATION) > -1) {
      setTimeout(() => {
        window.scrollTo(1, 1);
      }, 1200);
    }
  }

  fetchLineaUp = () => {};

  getCarrouselComponent(carrousel, key) {
    const emptyView = <div />;
    const { title, type, byuser, name, typeParent } = carrousel;
    let { url } = carrousel;
    const nameCarousel =
      name !== undefined ? Utils.rmSpecialCharacters(name.toUpperCase()) : '';

    if (typeParent === CAROUSEL_MUSIC) {
      if (this.props.user.userType !== ANONYMOUS)
        return (
          <CarouselMusic
            id={carrousel.id}
            url={carrousel.url}
            title={carrousel.title}
            data={carrousel.data}
          />
        );
      return null;
    }
    if (
      byuser === 'true' &&
      (!carrousel.extended || this.props.user.userType === ANONYMOUS)
    ) {
      return emptyView;
    }

    if (byuser === 'true' && carrousel.extended) {
      if (url && url.indexOf('filterlist') === -1) {
        const filterId = Utils.getNewFilters(this.props.metadata);
        url = `${url}&filterlist=${filterId}`;
      }
      if (nameCarousel === CAROUSEL.POR_GRABAR) {
        url = `${url}&${Utils.buildQueryStringParams({
          user_token: JSON.parse(
            localStorage.getItem('loginInfo.logged_user_data'),
          ).token,
        })}`;
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              carrouselData={carrousel}
              recording
              nameCarousel={CAROUSEL.POR_GRABAR}
            />
          </NavigationWrapper>
        );
      }

      if (nameCarousel === CAROUSEL.MIS_PROGRAMAS_GRABADOS) {
        url = `${url}&${Utils.buildQueryStringParams({
          user_token: JSON.parse(
            localStorage.getItem('loginInfo.logged_user_data'),
          ).token,
        })}`;
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              carrouselData={carrousel}
              recording
              nameCarousel={CAROUSEL.MIS_PROGRAMAS_GRABADOS}
            />
          </NavigationWrapper>
        );
      }

      if (
        nameCarousel === CAROUSEL.POR_VER ||
        nameCarousel === CAROUSEL.MI_LISTA
      ) {
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              isMyList
              carrouselData={carrousel}
            />
          </NavigationWrapper>
        );
      }

      if (
        nameCarousel === CAROUSEL.ACTIVIDAD_RECIENTE ||
        nameCarousel === CAROUSEL.CONTINUA_VIENDO
      ) {
        // Validamos si la url tiene filterList, si no lo trae, agregar los de metadata, si sí lo trae, no hacemos nada
        if (url && url.indexOf('filterlist') === -1) {
          const filterId = Utils.getNewFilters(this.props.metadata);
          url = `${url}&filterlist=${filterId}`;
        }

        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              carrouselData={carrousel}
              isSeenList
            />
          </NavigationWrapper>
        );
      }

      if (
        nameCarousel === CAROUSEL.COMPRADOS_RENTADOS ||
        nameCarousel === CAROUSEL.COMPRADOS_Y_RENTADOS
      ) {
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              isBuyList
              titleDefault={title}
              carrouselData={carrousel}
              progressBar
            />
          </NavigationWrapper>
        );
      }

      if (
        nameCarousel === CAROUSEL.RECOMENDADOR_1 ||
        nameCarousel === CAROUSEL.RECOMENDADOR_2 ||
        nameCarousel === CAROUSEL.RECOMENDADOR_3
      ) {
        return (
          <Recommended
            key={key}
            user={this.props.user}
            translations={this.props.translations}
            config={this.props.config}
            url={url}
            name={nameCarousel}
            carrouselData={carrousel}
          />
        );
      }

      if (nameCarousel === CAROUSEL.PARA_TI) {
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              carrouselData={carrousel}
            />
          </NavigationWrapper>
        );
      }

      if (this.props.carousel) {
        if (type === 'carrouseldoble') {
          carrousel.carrousels.forEach(mCarrousel => {
            const filterId = Utils.getNewFilters(this.props.metadata);
            mCarrousel.url += `&filterlist=${filterId}`;
          });
          return (
            <CarrouselDouble
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              carrouselData={carrousel}
            />
          );
        }
        // Carrusels by user dependencies of favorites
        if (this.props.carousel.favorites.length > 0) {
          if (
            nameCarousel === CAROUSEL.RECOMENDADOR_2 ||
            nameCarousel === CAROUSEL.RECOMENDADOR_3
          ) {
            return (
              <NavigationWrapper>
                <Recommended
                  key={key}
                  user={this.props.user}
                  translations={this.props.translations}
                  config={this.props.config}
                  url={url}
                  name={nameCarousel}
                  carrouselData={carrousel}
                />
              </NavigationWrapper>
            );
          }
        }
        return null;
      }

      return (
        <NavigationWrapper>
          <ContentList
            key={key}
            user={this.props.user}
            translations={this.props.translations}
            config={this.props.config}
            url={url}
            titleDefault={title}
            carrouselData={carrousel}
          />
        </NavigationWrapper>
      );
    }
    if (byuser !== 'true') {
      if (carrousel.type === 'Listadoinfinito') {
        return (
          <NavigationWrapper>
            <InfiniteList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              query={this.props.params}
              carrouselData={carrousel}
            />
          </NavigationWrapper>
        );
      }

      if (type === TYPE_HIGHLIGHT) {
        return (
          <NavigationWrapper>
            <SuperHighlight
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              query={this.props.params}
              url={url}
              carrouselData={carrousel}
            />
          </NavigationWrapper>
        );
      }

      if (type === TYPE_HORIZONTAL) {
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              user={this.props.user}
              translations={this.props.translations}
              config={this.props.config}
              url={url}
              titleDefault={title}
              claroRecomendation
              carrouselData={carrousel}
            />
          </NavigationWrapper>
        );
      }

      if (type === TYPE_VERTICAL) {
        const enableQatar = this.props.qatar?.default?.enable;
        if (this.props.qatar?.default?.enable) {
          if (enableQatar[this.props.user.userType.toLowerCase()]) {
            if (carrousel.deepType === 'soccermatcher') {
              return <CarouselMatch carrousel={carrousel} />;
            }
            if (carrousel.deepType === 'soccerteams') {
              return <CarouselSeleccion carrousel={carrousel} />;
            }

            return (
              <NavigationWrapper>
                <ContentList
                  key={key}
                  user={this.props.user}
                  translations={this.props.translations}
                  config={this.props.config}
                  url={url}
                  titleDefault={title}
                  carrouselData={carrousel}
                />
              </NavigationWrapper>
            );
          } else {
            if (
              carrousel.deepType === 'soccermatcher' ||
              carrousel.deepType === 'soccerteams'
            ) {
              return <></>;
            }
            return (
              <NavigationWrapper>
                <ContentList
                  key={key}
                  user={this.props.user}
                  translations={this.props.translations}
                  config={this.props.config}
                  url={url}
                  titleDefault={title}
                  carrouselData={carrousel}
                />
              </NavigationWrapper>
            );
          }
        } else {
          return (
            <NavigationWrapper>
              <ContentList
                key={key}
                user={this.props.user}
                translations={this.props.translations}
                config={this.props.config}
                url={url}
                titleDefault={title}
                carrouselData={carrousel}
              />
            </NavigationWrapper>
          );
        }
      }

      if (type === 'playAndGo') {
        return (
          <NavigationWrapper>
            <ContentList
              key={key}
              carrouselPlayAndGo={carrousel.carosuel}
              blockFetch
              playAndGoNodes
            />
          </NavigationWrapper>
        );
      }
      return null;
    }

    return null;
  }

  renderCarouselByType(carrousel, key) {
    const { type, name } = carrousel;
    const carrouselComponent = this.getCarrouselComponent(
      carrousel,
      `${type}-${name}-${key}`,
    );
    if (
      type === TYPE_HIGHLIGHT ||
      type === 'carrouseldoble' ||
      name === 'recomendador_1'
    ) {
      return carrouselComponent;
    }

    return (
      <LazyLoad
        key={`${type}-${key}`}
        height={key <= 6 ? 200 : ''}
        offset={100}
      >
        {carrouselComponent}
      </LazyLoad>
    );
  }

  renderCarousels = () => {
    if (!this.props.carousel.carrousels) {
      return null;
    }

    const { carrousels } = this.props.carousel;
    // Check if playAndGo is not already enqueue
    const parent = findNodeMainParentByCode(
      this.props.nav,
      this.props.currentNode.code,
    );
    if (this.props.isNewNavigationExperience) {
      const LAYOUT = _.get(this.props.currentNode, ['appBehavior', 'layout']);

      if (LAYOUT === 'playandgo' && carrousels[0].type !== 'playAndGo') {
        carrousels.unshift(
          nodeToCarousel(this.props.currentNode, this.props.assets),
        );
      }
    } else if (
      parent &&
      parent.code === 'playandgo' &&
      carrousels[0].type !== 'playAndGo'
    ) {
      carrousels.unshift(
        nodeToCarousel(this.props.currentNode, this.props.assets),
      );
    }

    const isRecording = nameCarousel =>
      nameCarousel === CAROUSEL.POR_GRABAR ||
      nameCarousel === CAROUSEL.MIS_PROGRAMAS_GRABADOS;
    const isMisContenidos = nameCarousel =>
      nameCarousel === CAROUSEL.COMPRADOS_Y_RENTADOS ||
      nameCarousel === CAROUSEL.COMPRADOS_RENTADOS;

    const constraints = carrousels.reduce(
      (prev, carrousel) => {
        const nameCarousel =
          carrousel.name !== undefined
            ? Utils.rmSpecialCharacters(carrousel.name.toUpperCase())
            : '';
        return {
          isRecording: prev.isRecording || isRecording(nameCarousel),
          isMisContenidos:
            prev.isMisContenidos || isMisContenidos(nameCarousel),
        };
      },
      {
        isRecording: false,
        isMisContenidos: false,
      },
    );

    const carrouselsMapped = carrousels.map((carrousel, index) => {
      const carrouselComponent = this.renderCarouselByType(carrousel, index);
      return carrouselComponent;
    });

    this.noElementsRecording = null;

    const { translations, carousel } = this.props;
    const carouselsAreEmpty = !Utils.thereAtLeastOneElement(carousel.findById);

    if (carouselsAreEmpty) {
      if (constraints.isRecording) {
        this.noElementsRecording = (
          <div className="content-list inline-alert">
            <h1>
              {converter.convertApaUnicode(
                translations,
                'recording_empty_section_title',
                'Aún no tienes contenido grabado.',
              )}
            </h1>
            <p>
              {`${converter.convertApaUnicode(
                translations,
                'recording_empty_section_line1',
                'Recuerda que',
              )} ${converter.convertApaUnicode(
                translations,
                'recording_empty_section_line2',
                'tus películas y series favoritas grabadas',
              )} ${converter.convertApaUnicode(
                translations,
                'recording_empty_section_line3',
                'las podrás encontrar aquí.',
              )}`}
            </p>
          </div>
        );
      }

      if (constraints.isMisContenidos) {
        this.noElementsRecording = (
          <div className="content-list inline-alert">
            <h1>{`${converter.convertApaUnicode(
              translations,
              'mycontent_empty_section_title1',
              'Aún no has',
            )} ${converter.convertApaUnicode(
              translations,
              'mycontent_empty_section_title2',
              'visto, comprado o rentado',
            )} ${converter.convertApaUnicode(
              translations,
              'mycontent_empty_section_title3',
              'ningun contenido.',
            )}`}</h1>
            <p>{`${converter.convertApaUnicode(
              translations,
              'mycontent_empty_section_line1',
              'Recuerda que lo',
            )} ${converter.convertApaUnicode(
              translations,
              'mycontent_empty_section_line2',
              'podras ver aqui.',
            )}`}</p>
          </div>
        );
        /** TODO: REFACTOR ->
          Esto no debería de ser así, si llega otro tipo de carusel que se tenga que poner en la primera posición
          o no se deba poner nada no funcionará, el funcionamiento correcto es mas complicado, puesto que es una validaciíon
          en al momento de renderisar al componente padre el que impide que se haga la actualización para que desaparezca.
          Al hacer scroll funciona correctamente (Se ocultan los listados que deben) pues el scroll dispara una acción con
          una petición a un servicio para pedir otro listado y hace que la renderización la cual queda atorada continue.
        */
        //  return carrouselsMapped;
      }
    }
    return carrouselsMapped;
  };

  handleChange(event, opt) {
    const route = `/${GetRegion()}/${opt.code}`;
    this.props.navigate(route);
  }

  render() {
    if (!this.props.config || !this.props.user) {
      return <LoadingSpinner />;
    }
    let filterSection = null;
    const LAYOUT = _.get(this.props, ['currentNode', 'appBehavior', 'layout']);
    if (LAYOUT === 'filterbygenre') {
      filterSection = <FiltersContainer node={this.props.currentNode} />;
    }

    return (
      <div
        className="main-wrapper"
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <CarouselsDisplay />
        {this.noElementsRecording}
        {this.props.location.pathname !==
          '/mexico/miscontenidos' && this.props.getTooltip.tooltipComponent}
      </div>
    );
  }
}

HomeCarousels.propTypes = {
  user: PropTypes.object,
  getTooltip: PropTypes.object,
  carousel: PropTypes.object,
  config: PropTypes.object,
  params: PropTypes.object,
  translations: PropTypes.object,
  metadata: PropTypes.object,
  currentNode: PropTypes.object,
  isNewNavigationExperience: PropTypes.bool,
  assets: PropTypes.object,
  nav: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapStateToProps = state => ({
  translations: state.translations,
  metadata: state.metadata,
  user: state.user,
  config: state.config,
  carousel: state.carousel,
  playAndGo: state.playAndGo,
  getTooltip: state.tooltip.getTooltip,
  node: getCurrentNode(state),
  assets: getAssets(state),
  nav: getNodesEnriched(state),
  currentNode: state.navigation.currentNode,
  isNewNavigationExperience: state.navigation.isNewNavigationExperience,
  estado: state,
  qatar: JSON.parse(state.metadata.qatar2022_enabled || '{}'),
});

const mapDispatchToProps = dispatch => ({
  nodeSelected: node => dispatch(nodeSelected(node)),
  fetchLineaUp: () => dispatch(fetchEpgLineaUp()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeCarousels);
